import API from 'services/API';

export default function updateNotifications(action, data) {
  return API.request({
    method: 'PUT',
    url: `/bell/update`,
    params: {
      action,
    },
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
